import * as SaveSearchPanelStyles from '../../../../../components/PageWrappers/AdDetails/components/SavedSearchPanel/styles';

import { useSavedSearchPanel } from '../../../../../components/PageWrappers/AdDetails/components/SavedSearchPanel/SavedSearchPanel.hook';

type SavedSearchPanelProps = { adId: number };

function SavedSearchPanel(props: SavedSearchPanelProps) {
  const { adId } = props;

  const { onOpen, isSearchSaved } = useSavedSearchPanel({ adId });

  return (
    <SaveSearchPanelStyles.SavedSearchContainer>
      <SaveSearchPanelStyles.IconAndTextContainer>
        <SaveSearchPanelStyles.Header>
          Get notified when similar ads are posted
        </SaveSearchPanelStyles.Header>
        <SaveSearchPanelStyles.Subtitle>
          Save this search to get notifications for ads like this
        </SaveSearchPanelStyles.Subtitle>
      </SaveSearchPanelStyles.IconAndTextContainer>
      <SaveSearchPanelStyles.SButton
        ofType="SECONDARY"
        onClick={onOpen}
        disabled={isSearchSaved}
        inline
      >
        Notify Me
      </SaveSearchPanelStyles.SButton>
    </SaveSearchPanelStyles.SavedSearchContainer>
  );
}

export { SavedSearchPanel };
export type { SavedSearchPanelProps };
